import { Colors } from "../constants/colors";
// import { FONT_FAMILIES, getEmFontSize } from "./styles";

export default {
  variants: [
    {
      props: { variant: "switch", color: "primary" },
      style: {
        "& .MuiButton-root": {
          "&.selected": {
            "&:hover": {
              borderColor: Colors.GREY300,
            },
          },
          "&:not(.selected)": {
            borderColor: Colors.GREY300,
            color: Colors.GREY350,
            "&:hover": {
              borderColor: Colors.GREY500,
              backgroundColor: Colors.GREY500,
              color: Colors.WHITE,
            },
          },
          ":disabled": {
            color: Colors.GREY300,
            backgroundColor: Colors.GREY250,
            borderColor: Colors.GREY250,
          },
        },
      },
    },
    {
      props: { variant: "switch", color: "secondary" },
      style: {
        "& .MuiButton-root": {
          "&:first-of-type": {
            "&.selected": {
              backgroundColor: Colors.BLUE500,
              borderColor: Colors.BLUE500,
              color: Colors.WHITE,
              "&:hover": {
                borderColor: Colors.GREY300,
                backgroundColor: Colors.WHITE,
                color: Colors.GREY500
              },
            },
            "&:not(.selected)": {
              borderColor: Colors.GREY300,
              backgroundColor: Colors.WHITE,
              color: Colors.GREY350,
              "&:hover": {
                borderColor: Colors.BLUE500,
                backgroundColor: Colors.BLUE500,
                color: Colors.WHITE,
              },
            },
          },
          "&:last-of-type": {
            "&.selected": {
              "&:hover": {
                borderColor: Colors.GREY300,
              },
            },
            "&:not(.selected)": {
              borderColor: Colors.GREY300,
              color: Colors.GREY350,
              "&:hover": {
                borderColor: Colors.GREY500,
                backgroundColor: Colors.GREY500,
                color: Colors.WHITE,
              },
            },
          },
          ":disabled": {
            color: Colors.GREY300,
            backgroundColor: Colors.GREY250,
            borderColor: Colors.GREY250,
          },
        },
      },
    },
  ],
};
